import { render } from "./EstimateForm.vue?vue&type=template&id=fc85fb16&scoped=true"
import script from "./EstimateForm.vue?vue&type=script&lang=js"
export * from "./EstimateForm.vue?vue&type=script&lang=js"

import "./EstimateForm.vue?vue&type=style&index=0&id=fc85fb16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc85fb16"]])

export default __exports__